import { I18NextModule } from 'angular-i18next';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './../../modules/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MakeUpExamFormComponent } from './make-up-exam-form.component';
import { BrowserModule } from '@angular/platform-browser';



@NgModule({
  declarations: [
    MakeUpExamFormComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,    
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    I18NextModule.forRoot(),
  ],
  exports: [
    MakeUpExamFormComponent
  ]
})
export class MakeUpExamFormModule { }
